const constants = {
	apiUrl: 'https://back-api.mirath.io/admin',
	gtm: '',
};

export default constants;
